export const AdditionalList: IAdditionalList = {
    kdt: [
      {
        id: 'addition1',
        icon: '/svg/icon_card.svg',
        title: '전액 지원 부트캠프',
        boldTitle: '내일배움카드 발급 대상',
        summary: '국민내일배움카드 발급 가능한 대상만 지원 가능',
        desc:
          '하며 빠르게 카드 발급 자격을 확인하려면 고용노동부 1350을 통해 대상 여부를 확인할 수 있어요.',
        boldDesc: '수강 기간 전까지 카드를 수령하셔야 수강이 가능',
        reference: '* 최근 5년 이내 KDT 과정을 수강한 경우 참여가 어려워요.',
        isOpen: false,
      },
      {
        id: 'addition2',
        icon: '/svg/icon_computer.svg',
        title: '취업 교육과정',
        boldTitle: '100% 온라인 실시간 라이브',
        desc: '되는 교육 과정을 참여할 수 있어야 과정 참여가 가능해요.',
        boldDesc: '주 5일, 09:00~18:00 (월~금) 진행',
        isOpen: false,
      },
    ],
    kdt_plus: [
      {
        id: 'addition3',
        icon: '/svg/icon_card.svg',
        title: '전액 지원 부트캠프',
        boldTitle: '내일배움카드 발급 대상',
        summary: '국민내일배움카드 발급 가능한 대상만 지원 가능',
        desc: '으로 기존에 국비지원교육(부트캠프 등)을 들었던 분도 참여가 가능합니다.',
        boldDesc: '취업 경쟁력을 높여줄 오프라인 프로젝트 중심의 단기과정',
        isOpen: false,
      },
      {
        id: 'addition4',
        icon: '/svg/icon_bookmark.svg',
        title: '프로젝트 중심 과정',
        boldTitle: '주 5일 풀타임 오프라인',
        desc: '되며 서울 오프라인 교육장으로 통학이 가능한 분들만 참여가 가능해요.',
        boldDesc: '주 5일, 09:30~18:00 (월~금) 약 10주에 걸쳐 진행',
        isOpen: false,
      },
    ],
    kdt_startup: [
      {
        id: 'addition5',
        icon: '/svg/icon_card.svg',
        title: '전액 지원 부트캠프',
        boldTitle: '내일배움카드 발급 대상',
        summary: '국민내일배움카드 발급 가능한 대상만 지원 가능',
        desc:
          '하며 빠르게 카드 발급 자격을 확인하려면 고용노동부 1350을 통해 대상 여부를 확인할 수 있어요.',
        boldDesc: '수강 시작 전까지 카드를 수령하셔야 수강이 가능',
        reference: '* 최근 5년 이내 KDT 과정을 수강한 경우 참여가 어려워요.',
        isOpen: false,
      },
      {
        id: 'addition6',
        icon: '/svg/icon_bagcase.svg',
        title: 'IT창업 온보딩 과정',
        boldTitle: '100% 오프라인',
        desc: '되며 동대문 교육장으로 통학이 가능한 분들만 참여가 가능해요.',
        boldDesc: '주 5일, 09:30~18:00 (월~금) 15주에 걸쳐 진행',
        isOpen: false,
      },
    ],
    kdc: [
      {
        id: 'addition7',
        icon: '/svg/icon_card.svg',
        title: '',
        boldTitle: '내일배움카드 크레딧으로 수강료 90% 지원',
        summary: 'K-디지털 기초역량훈련 전용 크레딧이란?',
        desc: 'KDT 지원금과는 별도로 제공되는 지원금이에요. 50만원의 크레딧이 기본으로 제공돼요.',
        boldDesc: '',
        isOpen: false,
        secondSummary: '내 크레딧 확인 방법',
        secondDesc:
          'HRD-Net 로그인 > 나의 정보 > 나의 카드 > 카드사용내역 > K-디지털 기초역량훈련 사용액 확인',
      },
      {
        id: 'addition8',
        icon: '/svg/icon_coin.svg',
        title: '',
        boldTitle: '크레딧이 1원만 남아있어도 수강 신청 가능',
        desc:
          '크레딧 지원금이 1원만 남아있어도 6주완성 수강이 가능해요. 최대 2개 강의까지 수강 가능하니 각 강의별로 수강 신청을 해주세요.',
        boldDesc: '',
        reference: '* 크레딧은 최초 사용일로부터 1년 이내에 사용이 가능해요.',
        isOpen: false,
      },
    ],
  }
  
  interface IAdditionalList {
    [courseType: string]: IAdditionalItem[]
  }
  export interface IAdditionalItem {
    id: string
    icon: string
    title: string
    boldTitle: string
    summary?: string
    desc: string
    boldDesc: string
    reference?: string
    isOpen: boolean
    secondSummary?: string
    secondDesc?: string
  }